export const DOLFIN_DSL_MATCHERS = {
  META: /^(deal\.)?\$(?!(SUM|AVG|COUNT|MAX|MIN|\d$)\b)(\w+)$/,
  OPERATOR:
    /^(and|or|not|then|else|contains|startswith|endswith|=|!=|<>|<|>|<=|>=|\(|\)|\*|\/|\+|-)$/,
  FUNCTION:
    /^(startofmonth|startofquarter|startofyear|endofmonth|endofquarter|endofyear|asdate|plusdays|minusdays|plusmonths|minusmonths|numquarter)$/,
  STRING: /^".*"$/,
  NUMBER: /^-?\d+(\.\d+)?$/,
  NULL: /^null$/
}
